export { default } from "@features/investments/screens/operator-screen";
